import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { FROALA_TOOLBAR_SMALL } from '@shared/components/froala/common';
import { FroalaComponent } from '@shared/components/froala/froala.component';
import { CipoFroalaOptions } from '@shared/components/froala/interfaces';
import { CipoDialogHeaderComponent, DirtyDialogBase } from '@shared/dialogs';
import { CipoDialogModule } from '@shared/modules';

export interface AnnotationDialogData {
  annotation?: string;
}

@Component({
  selector: 'cipo-annotation-dialog',
  imports: [CipoDialogHeaderComponent, CipoDialogModule, FlexLayoutModule, FroalaComponent, TranslateModule],
  templateUrl: './annotation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnotationDialogComponent extends DirtyDialogBase {
  protected readonly data = inject<AnnotationDialogData>(MAT_DIALOG_DATA);
  protected override readonly dialogRef = inject(MatDialogRef<AnnotationDialogComponent, string>);
  private readonly translate = inject(TranslateService);

  readonly isEdit = !!this.data.annotation;
  readonly content = signal(this.data.annotation ?? '');
  readonly submitted = signal(false);
  protected readonly isDirty = computed(() => (this.content() ?? '') !== (this.data.annotation ?? ''));

  readonly froalaOptions: CipoFroalaOptions = {
    ...FROALA_TOOLBAR_SMALL,
    placeholderText: this.translate.instant('modules.screenDesigner.annotationPlaceholder'),
    heightMin: 150,
  };

  save(): void {
    this.submitted.set(true);
    if (!this.content()) {
      return;
    }
    this.dialogRef.close(this.content());
  }
}
